/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum ConsoleInstanceType {
  connect = 'connect',
  datastore = 'datastore',
  form = 'form',
  funnelback = 'funnelback',
  matrix = 'matrix',
  unknown = 'unknown',
}

export enum ConsoleInstanceStatusCode {
  Subscribe = 'Subscribe',
  Provisioned = 'Provisioned',
  Deploying = 'Deploying',
  Live = 'Live',
  Paused = 'Paused',
  Error = 'Error',
}
